import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';

import {
  FacebookIcon,
  TwitterIcon,
} from 'react-share';

const ShareTab = ({ path }) => {
  const color = '#158FCE';
  const size = 32;

  const link = "https://www.netsurf.bg/" + path;
  return (
    <div className='row'>
      <hr className='normal' />
      <div className='d-flex w-100 justify-content-end align-items-center p-0 m-0'>
        <h3 className='mt-2 mr-2'>Сподели</h3>
        <div className='d-inline-block'>
          <FacebookShareButton className='d-inline-block mx-1' url={link}>
            <FacebookIcon size={size} round={true} iconBgStyle={{ fill: color }} />
          </FacebookShareButton>
          <TwitterShareButton className='d-inline-block mx-1' url={link}>
            <TwitterIcon size={size} round={true} iconBgStyle={{ fill: color }} />
          </TwitterShareButton>
        </div>
      </div>
      <hr className='normal-bottom' />
    </div>
  )
}

export default ShareTab;